<template>
  <div v-if="isAnonymousMember">
    <p-avatar
      :class="avatarClass"
    ></p-avatar>
    <span class="ml-4 font-italic">{{ $t('member.anonymousMember') }}</span>
  </div>
  <div v-else>
    <v-tooltip
      v-if="avatarOnly"
      bottom
    >
      <template v-slot:activator="{ on }">
      <span v-on="on">
        <p-avatar
          :color="contact.color"
          :email="contact.displayEmail"
          :char="contact.displayName[0]"
          :class="avatarClass"
        ></p-avatar>
        <slot></slot>
      </span>
      </template>
      <template v-if="isDisplayNameWithCompany">
        {{ contact.displayNameWithCompany }}
      </template>
      <template v-else>
        {{ contact.displayName }}
      </template>
      <span v-if="tooltip">{{ tooltip }}</span>
    </v-tooltip>

    <v-list-item v-else class="px-0">
      <p-avatar
        :color="contact.color"
        :email="contact.displayEmail"
        :char="contact.displayName[0]"
        :class="avatarClass"
        list-item-avatar
      ></p-avatar>
      <v-list-item-content
        :class="{ 'font-weight-medium': fontBold }"
      >
        <template v-if="isDisplayNameWithCompany">
          {{ contact.displayNameWithCompany }}
        </template>
        <template v-else>
          {{ contact.displayName }}
        </template>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>


<script>
import PAvatar from '@/components/PAvatar'


export default {
  components: {
    PAvatar
  },


  props: {
    contact: {
      type: Object,
      required: true
    },
    fontBold: {
      type: Boolean,
      default: false
    },
    avatarOnly: {
      type: Boolean,
      default: false
    },
    avatarClass: {
      type: String
    },
    tooltip: {
      type: String,
      default: ''
    },
    isDisplayNameWithCompany: {
      type: Boolean,
      default: true
    },
    isAnonymousMember: {
      type: Boolean,
      default: false
    }
  }
}
</script>
